//
// ResultMessage.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./ResultMessageLevel";
import "./MessageText";
import "./MessageParameter";

var ResultMessage = createModule("BIRD::ResultMessage", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        messageKey: 7,
        messageText: 1,
        messageLevel: 4,
        parameters: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ResultMessage;
